import { LitElement, html } from 'lit';
import { FsIcon } from '@cof/fs-icon-wc/fs-icon.js';
import { fs24Caution } from '@cof/fs-icons';
import { style } from './error-message.style.js';

FsIcon.add(fs24Caution);

class RefiErrorMessage extends LitElement {
  static get styles() {
    return style;
  }

  render() {
    return html`
      <div class="error-message-container">
        <fs-icon icon="fs-24-caution" variant="feedback-critical"></fs-icon>
        <fs-body-text size="tiny" variant="feedback-negative">We had a technical problem. Please try again later.</fs-body-text>
      </div>
    `;
  }
}

customElements.define('offer-error-message', RefiErrorMessage);
